import jwtDecode from 'jwt-decode';
import Vue from 'vue';
import axios from 'axios';


export const TOKEN_KEY = 'atok';
const REFRESH_TOKEN_KEY = 'artok';
const USER_FULL_NAME = 'ufn';
const USER_NAME = 'un';
export const USER_PRIVILEGE = 'up';
const USER_IS_ADMIN = 'isa';

let expiresToken = null;
let expiresRtoken = null;


export const login = async (username, password) => {
    try {
      const response = await axios.post('/api/auth/login', {
        "username": username,
        "password": password,
      },
    {
      withCredentials: true 
    });
  
      const data = response.data;
        if (data.token && data.refreshToken) {
        expiresToken = getTokenExpirationDate(data.token);
        expiresRtoken = getTokenExpirationDate(data.refreshToken);
        setAuthToken(data.token);
        setRefreshToken(data.refreshToken);
        setUsername(data.username);
        setIsAdmin(data.isAdmin);
        setPrivileges(data.privileges);
        setFullName(data.fullName);
        return data;
      } else {
        throw new Error('Login failed: No tokens returned');
      }

    } catch (error) {
      this.$snotify.error('Votre nom d\'utilisateur ou mot de passe est erroné.');
      throw error;
    }
  };


export const setRefreshToken = (token) => {
    try {
      Vue.$cookies.set(REFRESH_TOKEN_KEY, token, expiresRtoken);
    } catch (error) {
      console.error('Failed to decode refresh token:', error);
      Vue.$cookies.set(REFRESH_TOKEN_KEY, token);
    }
  };

export const removeRefreshToken = () => {
  Vue.$cookies.remove(REFRESH_TOKEN_KEY);
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const clearAuthData = () => {
  removeAuthToken();
  removeRefreshToken();
  removePrivileges();
  removeIsAdmin();
  removeUsername();
  removeFullName();
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  return {};
};


export const refreshAuthToken = async () => {
  const refreshToken = getRefreshToken();

  if (refreshToken) {
    try {
      const response = await axios.post('/api/auth/refresh-token', {
        refreshToken, 
      });

      return response.data;
    } catch (error) {
      return null;
    }
  }
  return null;
};


export const getTokenExpirationDate = (token) => {
  try {
    const decoded = jwtDecode(token);
    const expMs = decoded.exp * 1000;
    const now = Date.now();
    const durationMs = expMs - now;

    if (durationMs <= 0) {
      console.warn('Token already expired');
      return null;
    }

    const durationMinutes = Math.floor(durationMs / (1000 * 60));
    return `${durationMinutes}min`;
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};



  export const getAuthToken = () => {
  return Vue.$cookies.get(TOKEN_KEY) || null;
};

export const setAuthToken = (token) => {
    try {
      Vue.$cookies.set(TOKEN_KEY, token, expiresToken);
    } catch (error) {
      Vue.$cookies.set(TOKEN_KEY, token);
    }
  };

  
export const setFullName = (username) => {
    Vue.$cookies.set(USER_FULL_NAME, username, expiresToken);
};
export const removeFullName = () => {
    Vue.$cookies.remove(USER_FULL_NAME);
};
export const setUsername = (username) => {
    Vue.$cookies.set(USER_NAME, username,  expiresToken);
};
export const removeUsername = () => {
    Vue.$cookies.remove(USER_NAME);
};
export const setIsAdmin = (isAdmin) => {
    Vue.$cookies.set(USER_IS_ADMIN, isAdmin,  expiresToken);
};
export const removeIsAdmin = () => {
    Vue.$cookies.remove(USER_IS_ADMIN);
};
export const setPrivileges = (privileges) => {
    Vue.$cookies.set(USER_PRIVILEGE, privileges, expiresToken);
};
export const removePrivileges = () => {
    Vue.$cookies.remove(USER_PRIVILEGE);
};
export const removeAuthToken = () => {
  Vue.$cookies.remove(TOKEN_KEY);
};
export const getRefreshToken = () => {
  return Vue.$cookies.get(REFRESH_TOKEN_KEY) || null;
};